var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 207,
  height: 86,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 150,
  height: 35,
  x: 0.478,
  y: 0.523,
  fill: "#fff",
  rx: 7.5,
  transform: "matrix(.9989 .04693 -.04298 .99908 22.787 42.138)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#EEE",
  rx: 6,
  transform: "matrix(.9989 .04693 -.04298 .99908 34.493 48.718)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 81,
  height: 6,
  fill: "#EEE",
  rx: 3,
  transform: "matrix(.9989 .04693 -.04298 .99908 66.307 53.716)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 83,
  height: 6,
  fill: "#EEE",
  rx: 3,
  transform: "matrix(.9989 .04693 -.04298 .99908 65.835 64.706)"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 150,
  height: 35,
  x: 0.478,
  y: 0.523,
  stroke: "#EEE",
  rx: 7.5,
  transform: "matrix(.9989 .04693 -.04298 .99908 22.787 42.138)"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 192,
  height: 47,
  x: 1.407,
  y: 13.043,
  fill: "#fff",
  rx: 7.5
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 12.907,
  y: 20.543,
  fill: "#E0EDFF",
  rx: 8
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 81,
  height: 6,
  x: 52.907,
  y: 26.543,
  fill: "#E0EDFF",
  rx: 3
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 6,
  x: 52.907,
  y: 40.543,
  fill: "#E0EDFF",
  rx: 3
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 177.907,
  cy: 36.543,
  r: 4,
  fill: "#408BFC"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 192,
  height: 47,
  x: 1.407,
  y: 13.043,
  stroke: "#E0EDFF",
  rx: 7.5
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 2.061,
  height: 12.154,
  fill: "#408BFC",
  rx: 1.031,
  transform: "matrix(.5324 .84649 -.8243 .56616 203.833 5.223)"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 2.008,
  height: 7.275,
  fill: "#408BFC",
  rx: 1.004,
  transform: "matrix(.9403 .34036 -.31463 .94921 191.73 0)"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 2.084,
  height: 10.01,
  fill: "#408BFC",
  rx: 1.042,
  transform: "matrix(-.19901 .98 -.97628 -.2165 206 20.962)"
})));
export default SvgEmptyList;